import type { DialogRequest } from './types';
import type { OperationType } from '@mimir/common/dto/archiveOperationDto';
import type { SearchResultHit } from '@mimir/common/dto/searchResultHit';

export enum UpdateType {
  ITEMS = 'items',
  BULK = 'bulk'
}

export interface ArchiveBulkRequestCore extends DialogRequest {
  updateType: UpdateType;
  operationType: OperationType;
}

export interface ArchiveMultiple extends ArchiveBulkRequestCore {
  updateType: UpdateType.ITEMS;
  items: SearchResultHit[];
}

export interface ArchiveFolder extends ArchiveBulkRequestCore {
  updateType: UpdateType.BULK;
  folderInfo: { id: string, name: string };
}


export type ArchiveBulkRequest = ArchiveFolder | ArchiveMultiple;
